'use client';

import Link from 'next/link';
import React from 'react';

export default function RoomError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error('[rooms/error]', error);
  }, [error]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        background: '#111',
        color: '#eee',
      }}
    >
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>Erro ao carregar a reunião</h1>
        <p style={{ fontSize: '0.95rem', opacity: 0.85, marginBottom: '1.5rem' }}>
          Ocorreu uma exceção no navegador. Tente recarregar; se persistir, entre novamente pelo
          link da reunião.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: 6,
              border: 'none',
              background: '#3b82f6',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            Tentar novamente
          </button>
          <Link
            href="/"
            style={{
              padding: '0.5rem 1rem',
              borderRadius: 6,
              border: '1px solid #555',
              color: '#eee',
              textDecoration: 'none',
            }}
          >
            Início
          </Link>
        </div>
      </div>
    </div>
  );
}
